<template>
  <div class="footer">
    <div class="nav">
      <div class="list" v-for="(item, index) in navList" :key="index" @click="routeChange(item)">
        {{ item.name }}
      </div>
    </div>
    <div class="copy">Copyright @ 2026. All rights reserved</div>
    <!-- <div class="copy">zhengrongzrfly</div> -->
  </div>
</template>

<script setup>
import { ref, watch } from "vue"
import { useI18n } from "vue-i18n"
const { t, locale } = useI18n()

import { useRouter } from 'vue-router'
const router = useRouter()

const navList = ref([
  { name: t("navList.home"), path: "/index" },
  { name: t("navList.compare"), path: "/cooperation" },
  { name: t("navList.intro"), path: "/introduce" },
  //{ name: t("navList.info"), path: "/info" },
  { name: t("navList.aboutUs"), path: "/about" }
])

const routeChange = (data) => {
  router.push(data.path)
}

watch(locale, () => {
  navList.value = [
    { name: t("navList.home"), path: "/index" },
    { name: t("navList.compare"), path: "/cooperation" },
    { name: t("navList.intro"), path: "/introduce" },
   // { name: t("navList.info"), path: "/info" },
    { name: t("navList.aboutUs"), path: "/about" }
  ]
})
</script>

<style lang="less" scoped>
.footer {
  color: var(--text-primary);
  font-size: var(--fs-small);
  width: 100%;
  margin: 24px 0 0 0;
  .nav {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    .list {
      cursor: pointer;
      /* 分割线改用浅灰竖线字符，与示例一致 */
      &:not(:last-child)::after {
        content: '|';
        margin: 0 8px;
        color: #cbd5e1;
        font-weight: 300;
      }
    }
  }
  .copy {
    color: var(--text-caption);
    font-size: var(--fs-caption);
    font-weight: 400;
    text-align: center;
    margin: 10px 0 8px 0;
  }
}
/* ========== 移动端适配 ========== */
@media screen and (max-width: 767px) {
  .footer {
    padding: 0 15px;
    box-sizing: border-box;
    .nav {
      .list {
        font-size: var(--fs-caption);
        padding: 6px 0;
        &:not(:last-child)::after {
          margin: 0 5px;
        }
      }
    }
  }
}
</style>
